import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowRedoneSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.172 12H6.5a2.5 2.5 0 0 0 0 5H7v2h-.5a4.5 4.5 0 1 1 0-9h11.672l-3.586-3.586L16 5l6 6-6 6-1.414-1.415L18.172 12Z"
    />
  </svg>
);
export default IconArrowRedoneSizeM;
